import { FC } from 'react';
import { UploadProfilePicture, SmallLoader, ProfilePictureActions } from 'learning-panel-components';
import styles from './profilePicture.module.scss';

const ProfilePicture: FC<ProfilePicturesTypes> = (props: ProfilePicturesTypes) => {
    const { uploadImage, isLoading, actions, imgSrcUrl, imgSrc } = props;

    return (
        <div className={styles['profile-picture-wrapper']}>
            {isLoading ? (
                <SmallLoader size="100px" className={styles['loader-wrapper']} />
            ) : (
                <UploadProfilePicture
                    imageSrc={imgSrc}
                    imgSrcUrl={imgSrcUrl}
                    onUploadImage={uploadImage}
                    actions={actions}
                    isLarge
                />
            )}
        </div>
    );
};

interface ProfilePicturesTypes {
    uploadImage: Function;
    isLoading?: boolean;
    imgSrcUrl?: string;
    actions?: ProfilePictureActions[];
    imgSrc?: File;
}

export default ProfilePicture;
